import { generateClasses } from "@formkit/themes";
import { it, en, de, fr, es, ja, ko } from "@formkit/i18n";

const textfield = {
  wrapper: "flex flex-col gap-2xs w-full",
  label: "truncate text-body-small",
  input: `
        appearance-none
        w-full h-20 px-md 
        text-body-small text-skin-inverted 
        bg-skin-inverted 
        border border-skin-inverted !rounded-none
        focus:outline-none focus:shadow-none 
        placeholder-shown:text-center placeholder:text-skin-inverted/60 
        formkit-invalid:!text-red-500
    `,
};

// modificato il 19/10/2026: iOS (WebKit) ignora text-align sulle <select> → placeholder paese a sinistra; aggiunto text-align-last:center
// const selectField = {
//   wrapper: textfield.wrapper,
//   label: textfield.label,
//   input: `${textfield.input} data-[placeholder=true]:text-center data-[placeholder=true]:text-skin-inverted/60`,
// };
const selectField = {
  wrapper: textfield.wrapper,
  label: textfield.label,
  input: `${textfield.input} data-[placeholder=true]:text-center data-[placeholder=true]:[text-align-last:center] data-[placeholder=true]:text-skin-inverted/60`,
};

export default {
  // Define additional locales
  locales: { it, en, de, fr, es, ko, ja },
  // Define the active locale
  locale: "it",
  config: {
    classes: generateClasses({
      global: {
        form: "flex flex-col items-stretch gap-md w-full",
        outer: "formkit-disabled:opacity-40 w-full",
        label: "block text-skin-base text-left w-full",
        messages:
          "list-none flex flex-col justify-start items-stretch gap-xs pt-xs",
        message: "formkit-invalid:text-red-500 text-body-tiny text-left",
        help: "text-body-tiny text-skin-base/50",
      },
      form: {
        message: "!text-body !text-center text-red-500",
      },
      text: { ...textfield },
      email: { ...textfield },
      select: { ...selectField },
      radio: {
        outer: "flex flex-col",
        wrapper: "flex justify-start gap-xs items-baseline w-full",
        fieldset: "flex flex-col w-full",
        legend: "block text-skin-body text-skin-base text-left w-full pb-2xs",
        label: "cursor-pointer text-body-small",
        options: "flex gap-xl items-baseline",
        inner: "relative top-0 left-0 flex p-0 m-0 leading-none",
        input: `
                    appearance-none peer
                    w-4 h-4 border border-skin-inverted rounded-full
                `,
        decorator:
          "pointer-events-none absolute top-1 left-1 w-2 h-2 bg-transparent peer-checked:bg-skin-inverted rounded-full",
      },
      checkbox: {
        outer: "flex flex-col",
        wrapper: "flex justify-start gap-xs items-baseline w-full",
        label: "text-body-tiny cursor-pointer",
        inner: "relative top-0 left-0 flex p-0 m-0 leading-none",
        input: `
                    appearance-none peer
                    w-4 h-4 border border-skin-inverted
                `,
        decorator:
          "pointer-events-none absolute top-1 left-1 w-2 h-2 bg-transparent peer-checked:bg-skin-inverted",
      },
      submit: {
        outer: "pt-md",
        input:
          "inline-flex justify-center items-center gap-sm h-[66px] px-2xl border border-skin-inverted text-button-small text-skin-base bg-transparent hover:text-skin-inverted hover:bg-skin-inverted transition-colors duration-200 ease-in-out whitespace-nowrap whitespace-nowrap first-letter:uppercase",
      },
    }),
  },
};
